'kiwi public';

// What settings keys to ignore when building period delimited settings object
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var ignoreKeys = ['emojis', 'themes', 'bnc', 'aliases', 'restricted', 'kiwiServer', 'hide_advanced', 'windowTitle', 'startupOptions', 'plugins', 'presetNetworks', 'ircFramework'];

// Converts settings object to period delimited key based object
// eg { buffers.alert_on: false }
export function buildTree(data, base, object, modified) {
  _Object$keys(object).forEach(function (key) {
    var value = object[key];
    var ourBase = _concatInstanceProperty(base).call(base, [key]);
    if (['string', 'boolean', 'number'].indexOf(_typeof(value)) !== -1) {
      if (ignoreKeys.indexOf(key) !== -1 || (ourBase[0] && ignoreKeys.indexOf(ourBase[0])) !== -1) {
        return;
      }
      if (!data[ourBase.join('.')] || data[ourBase.join('.')].val !== value) {
        data[ourBase.join('.')] = {
          key: ourBase.join('.'),
          val: value,
          type: _typeof(value),
          modified: modified
        };
      }
    } else if (_typeof(value) === 'object' && value !== null) {
      buildTree(data, ourBase, value, modified);
    }
  });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["settingTools"]
window._kiwi_exports.libs.settingTools = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
